// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesMicroLab = {
  microLabLibraryEntry: "Micro Lab 库条目",
  microLabMember: "Micro Lab 成员",
  microLabRelease: "Micro Lab 发布",
  microLabRun: "Micro Lab 运行",
  microLabScheme: "Micro Lab 方案",
  microLabSchemeVersion: "Micro Lab 方案版本",
  microLabAuth: "Micro Lab 认证",
  microLabLibrary: "Micro Lab 库",
} as const;
